module.exports = __webpack_public_path__ + "img/gmp5.b6b2f793.png";